import type { SaveStorage } from '../saves/storage';

export const PROGRESSION_KEY = 'ironvein.progression.v1';

export interface Progression {
  victories: number;
  deepeningUnlocked: boolean;
}

export const DEFAULT_PROGRESSION: Progression = {
  victories: 0,
  deepeningUnlocked: false,
};

export function loadProgression(storage?: SaveStorage): Progression {
  if (!storage) return { ...DEFAULT_PROGRESSION };
  try {
    const raw = storage.getItem(PROGRESSION_KEY);
    if (!raw) return { ...DEFAULT_PROGRESSION };
    const parsed = JSON.parse(raw) as Partial<Progression>;
    if (!Number.isInteger(parsed.victories) || (parsed.victories ?? -1) < 0 ||
      typeof parsed.deepeningUnlocked !== 'boolean') {
      return { ...DEFAULT_PROGRESSION };
    }
    return { victories: parsed.victories ?? 0, deepeningUnlocked: parsed.deepeningUnlocked };
  } catch {
    return { ...DEFAULT_PROGRESSION };
  }
}

export function recordVictory(current: Progression, storage?: SaveStorage): Progression {
  const next = { victories: current.victories + 1, deepeningUnlocked: true };
  storage?.setItem(PROGRESSION_KEY, JSON.stringify(next));
  return next;
}
